import React, { useState } from 'react';
import { NetworkStatus } from '@apollo/client';
import { useRouteMatch } from 'react-router-dom';
import { Grid, Typography, ListItemText, Card } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { userLanguage } from '../../../../core/AuthContext';
import { ErrorComponent, LoadingSpinner } from '../../../../components';
import SymbolDetails from './SymbolDetails';

import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { ProducerNavigation } from '../../navigation/ProducerNavigation';

const SymbolsCollectionDetails: React.FC<any> = ({ party }) => {
  const symbolCollectionId = ProducerNavigation.symbolCollectionDetails.paramsFromPath(useRouteMatch())
    .symbolCollectionId;

  const [errorComponentState, setErrorComponentState] = useState(false);
  const { t: translate } = useTranslation();

  const {
    loading: symbolCollectionLoading,
    error: symbolCollectionError,
    data: symbolCollectionData,
    refetch: refetchSymbolCollection,
    networkStatus: symbolCollectionNetworkStatus
  } = GQLOperationBuilder.symbolCollection.getSymbolCollection({ symbolCollectionId: symbolCollectionId });

  const {
    loading: symbolListLoading,
    error: symbolListError,
    networkStatus: symbolListNetworkStatus,
    data: symbolListData,
    refetch: refetchSymbolsList
  } = GQLOperationBuilder.symbol.getSymbolsBySymbolCollection({ symbolCollectionId: symbolCollectionId });

  if (
    symbolListLoading ||
    symbolCollectionLoading ||
    symbolCollectionNetworkStatus === NetworkStatus.refetch ||
    symbolListNetworkStatus === NetworkStatus.refetch
  )
    return <LoadingSpinner />;

  if (symbolCollectionError && !errorComponentState)
    return (
      <ErrorComponent
        close={setErrorComponentState}
        details={symbolCollectionError?.stack}
        message={symbolCollectionError.message}
        callback={() => refetchSymbolCollection()}
      />
    );

  if (symbolListError && !errorComponentState)
    return (
      <ErrorComponent
        close={setErrorComponentState}
        details={symbolCollectionError?.stack}
        message={symbolListError.message}
        callback={() => refetchSymbolsList()}
      />
    );

  return (
    <Card style={{ margin: '10px 0', padding: '8px' }}>
      <div style={{ display: 'flex' }}>
        <Typography style={{ marginRight: '2px' }} variant="h4">
          {
            GQLOperationBuilder.symbolCollection.symbolCollectionFromResponse(symbolCollectionData).title[
              userLanguage
            ]
          }
        </Typography>
      </div>

      <ListItemText
        primary="Collection Name"
        secondary={
          GQLOperationBuilder.symbolCollection.symbolCollectionFromResponse(symbolCollectionData).title[
            userLanguage
          ]
        }
      />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <ListItemText primary="Symbols" />
      </div>

      <Grid style={{ marginTop: '20px' }} container direction="row" spacing={2}>
        {GQLOperationBuilder.symbol
          .symbolAssetArrayFromResponse(symbolListData)
          .map(a => a)
          .sort((s1, s2) => s1.symbol.title.en!.localeCompare(s2.symbol.title.en!))
          .map(symbol => (
            <Grid key={symbol.id} item xs={2} direction="column">
              <SymbolDetails key={symbol.id} symbolAsset={symbol} />
            </Grid>
          ))}
      </Grid>
    </Card>
  );
};

export default SymbolsCollectionDetails;
